import { call, put, takeEvery, select, delay } from "redux-saga/effects";
import * as orderCardActions from "../actions/orderCard";
import {
  getOrderByIdRequest,
  createOrderRequest,
  updateOrderRequest,
  getOrderReportRequest,
  downloadContractByOrderIdRequest
} from "../../api/orderCard";
import history from "../../../../../common/history";
import { errorProcessing } from "../../../../Employees/api/errorProcessing";
import { orderErrorResponse } from "../../api/orderCard/dataAdjustment";
import showSuccessWindow from "../../../../../common/components/successPopup/successPopup";
import {
  successCreateOrder,
  successArchieveOrder,
  successUpdateOrder
} from "../../components/OrderCard/popup/success";
import { archieveOrderRequest } from "../../api/orderCard/deleteOrderRequest";
import { message } from "antd";
import { downloadNotificationByOrderId } from "../../api/orderCard/downloadNotificationByOrderIdRequest";
import { createMonetizationTemplateRequest } from "../../../Offer/api/offerCreate/createMonetizationTemplateRequest";
import { getOrderSurchargePaymentRequest } from "../../api/orderCard/getOrderSurchargePaymentRequest";
import { assignDriverRequest } from "../../api/orderCard/selectDriverRequest";

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

const getActiveOrderId = state => {
  return (
    state.Executorship &&
    state.Executorship.Orders &&
    state.Executorship.Orders.orderCard &&
    state.Executorship.Orders.orderCard.data &&
    state.Executorship.Orders.orderCard.data.id
  );
};

function* getOrderByIdSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(
        getOrderByIdRequest,
        activeProfileId,
        action.payload
      );
      yield put(orderCardActions.getOrderByIdSuccess(response));
    } catch (err) {
      yield put(orderCardActions.getOrderByIdError(errorProcessing(err)));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(orderCardActions.getOrderById(action.payload))
      : history.push("/authorization/profiles");
  }
}

function* createOrderSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  const { data, ymaps } = action.payload;
  if (activeProfileId) {
    try {
      const response = yield call(
        createOrderRequest,
        activeProfileId,
        data,
        ymaps
      );
      if (response) {
        if (
          action.payload.monetizationTemplateNameCheck &&
          action.payload.monetizationTemplateName
        ) {
          yield call(
            createMonetizationTemplateRequest,
            activeProfileId,
            action.payload
          );
        }

        yield put(orderCardActions.createOrderSuccess());
        showSuccessWindow(successCreateOrder(response.offer.number));
        history.push("/executorship/order");
      }
    } catch (err) {
      let errData = errorProcessing(err, orderErrorResponse);
      if (errData.message) {
        message.error(errData.message);
      }
      yield put(orderCardActions.createOrderError(errData));
    }
  } else {
    history.push("/authorization/profiles");
  }
}

function* updateOrderSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(
        updateOrderRequest,
        activeProfileId,
        action.payload
      );
      yield put(orderCardActions.updateOrderSuccess(response));
      showSuccessWindow(
        successUpdateOrder(response.number, response.orderName)
      );
      history.push("/executorship/order");
    } catch (err) {
      let errData = errorProcessing(err, orderErrorResponse);
      yield put(orderCardActions.updateOrderError(errData));
    }
  } else {
    history.push("/authorization/profiles");
  }
}

function* getOrderReportSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(getOrderReportRequest, action.payload);
      if (response) {
        yield put(orderCardActions.getOrderReportSuccess(response));
      }
    } catch (err) {
      let errData = errorProcessing(err);
      yield put(orderCardActions.getOrderReportError(errData));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(orderCardActions.getOrderReport(action.payload))
      : history.push("/authorization/profiles");
  }
}

function* downloadContractByOrderIdSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(
        downloadContractByOrderIdRequest,
        activeProfileId,
        action.payload
      );
      if (response) {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", `contract-${action.payload}.pdf`);
        document.body.appendChild(link);
        link.click();
        yield put(orderCardActions.downloadContractByOrderIdSuccess(response));
      }
    } catch (err) {
      let errData = errorProcessing(err);
      yield put(orderCardActions.downloadContractByOrderIdError(errData));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(orderCardActions.downloadContractByOrderId(action.payload))
      : history.push("/authorization/profiles");
  }
}

function* downloadNotificationToGibddSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const { orderId, emailgibdd, number } = action.payload;
      const response = yield call(
        downloadNotificationByOrderId,
        activeProfileId,
        orderId,
        emailgibdd
      );
      if (response) {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute(
          "download",
          `Уведомление в ГИБДД_Заказ_${number}.pdf`
        );
        document.body.appendChild(link);
        link.click();
        yield put(
          orderCardActions.downloadNotificationToGibddSuccess(response)
        );
      }
    } catch (err) {
      let errData = errorProcessing(err);
      yield put(orderCardActions.downloadNotificationToGibddError(errData));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(orderCardActions.downloadNotificationToGibdd(action.payload))
      : history.push("/authorization/profiles");
  }
}

function* archieveOrderSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(
        archieveOrderRequest,
        action.payload,
        activeProfileId
      );
      showSuccessWindow(successArchieveOrder(response.data.offerId.number));
      history.push("/executorship/order");
    } catch (err) {
      let errData = errorProcessing(err, orderErrorResponse);
      yield put(orderCardActions.createOrderError(errData));
    }
  } else {
    history.push("/authorization/profiles");
  }
}

function* orderCardActionsSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const response = yield call(
        getOrderSurchargePaymentRequest,
        action.payload
      );
      if (response.status === 200) {
        yield put(
          orderCardActions.getSurchargePaymentDataSuccess(response.data)
        );
      }
    } catch (err) {
      let errData = errorProcessing(err);
      yield put(orderCardActions.getSurchargePaymentDataFailure(errData));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(orderCardActions.getOrderReport(action.payload))
      : history.push("/authorization/profiles");
  }
}

function* assignDriverSaga(action) {
  const { driver_id, offer_id } = action.payload;
  try {
    const response = yield call(assignDriverRequest, offer_id, driver_id);
    if (response.status === 200) {
      if (response.data.result) {
        message.success(response.data.message);
        const id = yield select(getActiveOrderId);
        yield put(orderCardActions.assignDriverSuccess());
        yield put(orderCardActions.setAssignDriverDrawerVisibility(false));
        yield put(orderCardActions.getOrderById(id));
      }
    }
  } catch (err) {
    let errData = errorProcessing(err);
    yield put(orderCardActions.assignDriverFailure(errData));
  }
}

export function* orderCardConfigWatcher() {
  yield takeEvery(orderCardActions.getOrderById.toString(), getOrderByIdSaga);
  yield takeEvery(orderCardActions.createOrder.toString(), createOrderSaga);
  yield takeEvery(orderCardActions.updateOrder.toString(), updateOrderSaga);
  yield takeEvery(orderCardActions.assignDriver.toString(), assignDriverSaga);
  yield takeEvery(
    orderCardActions.getOrderReport.toString(),
    getOrderReportSaga
  );
  yield takeEvery(
    orderCardActions.downloadContractByOrderId.toString(),
    downloadContractByOrderIdSaga
  );
  yield takeEvery(
    orderCardActions.downloadNotificationToGibdd.toString(),
    downloadNotificationToGibddSaga
  );
  yield takeEvery(orderCardActions.archieveOrder.toString(), archieveOrderSaga);

  yield takeEvery(
    orderCardActions.getSurchargePaymentData.toString(),
    orderCardActionsSaga
  );
}
